import React from 'react';

import { Icon } from '@rbilabs/components-library';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';

import { useFeatureMemberships } from 'hooks/use-feature-memberships';
import { useNativeStatusBar } from 'hooks/use-native-status-bar';

import {
  BackButton,
  BrandAndIconContainer,
  CardDescription,
  Container,
  InformationCardImage,
  InformationCardTextsContainer,
  InformationCardTitle,
  LinkAccountButton,
  Loading,
  MembershipLogo,
  MembershipName,
  MembershipNameCard,
  Tile,
  Widgets,
  WidgetsContainer,
} from './styled';

const MembershipDetails = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { nativeStatusBarExist } = useNativeStatusBar();

  const { featureMemberships, featureMembershipsLoading } = useFeatureMemberships();

  const { state } = useLocation();

  if (!state?.selectedMembership) {
    navigate(formatMessage({ id: 'routes.memberships' }));
    return null;
  }

  const membership = featureMemberships?.liveMemberships?.find(
    membership => membership?._id === state.selectedMembership
  );

  const handleBackButtonClick = () => {
    navigate(formatMessage({ id: 'routes.memberships' }));
  };

  const handleActionButton = () => {
    navigate(
      membership?.membershipPageConfiguration?.actionButtonLink?.locale ||
        formatMessage({ id: 'routes.memberships' })
    );
  };

  const hasWidgets = membership?.membershipPageConfiguration?.informationWidgets?.widgets?.length;

  return featureMembershipsLoading ? (
    <Loading fillColor={Styles.color.secondary} />
  ) : (
    <>
      <Container nativeStatusBarExist={nativeStatusBarExist}>
        <Helmet
          title={formatMessage(
            { id: 'membershipName' },
            { membershipName: membership?.membershipName }
          )}
        />
        <BrandAndIconContainer>
          <BackButton onClick={handleBackButtonClick}>
            <Icon icon="back" color="icon-header-contrast" width="24px" aria-hidden />
          </BackButton>
          <MembershipName>{membership?.membershipName}</MembershipName>
        </BrandAndIconContainer>
        <MembershipLogo
          image={membership?.membershipPageConfiguration?.membershipPageStyle?.image}
          alt="membership brand"
        />
        {hasWidgets && (
          <WidgetsContainer>
            <MembershipNameCard>
              {formatMessage(
                { id: 'membershipName' },
                { membershipName: membership?.membershipName }
              )}
            </MembershipNameCard>
            <Widgets>
              {membership?.membershipPageConfiguration?.informationWidgets?.widgets?.map(
                (widget, index) => (
                  <Tile
                    key={widget?.title?.locale}
                    data-testid={`information-card-${index}`}
                    $bgColor={widget?.widgetBackgroundColor?.hex}
                  >
                    <InformationCardImage image={widget?.widgetImage?.locale} alt="" />
                    <InformationCardTextsContainer>
                      <InformationCardTitle>{widget?.title?.locale}</InformationCardTitle>
                      <CardDescription content={widget?.description?.locale} />
                    </InformationCardTextsContainer>
                  </Tile>
                )
              )}
            </Widgets>
          </WidgetsContainer>
        )}

        <LinkAccountButton onClick={handleActionButton}>
          {membership?.membershipPageConfiguration?.actionButtonText?.locale}
        </LinkAccountButton>
      </Container>
    </>
  );
};

export default MembershipDetails;
